import createAxios from './axiosHttp';

function getShipments(pagination,filters) {
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/shipment`;
    if (pagination) {
        urlPath += `?page=${pagination.currentPage - 1}&limit=${pagination.rows}`;
    } else {
        urlPath += '?page=0&limit=20';
    }
    if (filters && filters.search) {
        urlPath += `&search=${encodeURIComponent(filters.search)}`;
    }
    if (filters && filters.status) {
        urlPath += `&status=${filters.status}`;
    }
    if (filters && filters.sort) {
        if(filters.sort.sort){
            urlPath += `&sort=${filters.sort.sort}`;
        }
        if(filters.sort.order){
            urlPath += `&order=${filters.sort.order}`;
        }
    }
    if (filters && filters.date.start) {
        urlPath += `&start_date=${filters.date.start}`
    }
    if (filters && filters.date.end) {
        urlPath += `&end_date=${filters.date.end}`
    }
    return axios.get(urlPath);
}
function getShipmentById(id){
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/shipment/${id}`;
    return axios.get(urlPath);
}
function getShipmentsAsExcel(filters, language) {
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/shipment/${language}/report`;
    urlPath += `?page=0&limit=1000000`;
    if (filters && filters.search) {
        urlPath += `&search=${encodeURIComponent(filters.search)}`;
    }
    if (filters && filters.status) {
        urlPath += `&status=${filters.status}`;
    }
    if (filters && filters.date.start) {
        urlPath += `&start_date=${filters.date.start}`
    }
    if (filters && filters.date.end) {
        urlPath += `&end_date=${filters.date.end}`
    }
    return axios.get(urlPath, {
        responseType: 'blob'
    });
}

function getResources(shipmentId) {
    const axios = createAxios();
    const user = JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/shipment/${shipmentId}/resources`;
    return axios.get(urlPath);
}

function downloadResource(shipmentId, fileName){
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/shipment/${shipmentId}/resources?filename=${fileName}`;
    return axios.get(urlPath, {
        responseType: 'blob'
    });
}

export const shipmentService = { getShipments,getShipmentById,getShipmentsAsExcel, getResources, downloadResource };